// extracted by mini-css-extract-plugin
module.exports = {"badge":"_3tRRAQ3hCssGzYTHWSrKk2"};